import styles from './AssetPositionTooltip.module.scss';
import { Tooltip } from 'react-leaflet';
import { PropsWithChildren, ReactElement } from 'react';

export interface AssetPositionTooltipProps {
  title: string;
  pane?: string; // This value must match the name of a custom pane that is mounted in the map.
}

export const AssetPositionTooltip = ({
  title,
  pane,
  children,
}: PropsWithChildren<AssetPositionTooltipProps>): ReactElement => {
  // Note: ReactLeaflet allows providing an 'undefined' pane, but it triggers a runtime error.
  // Only add a pane name prop if one has been defined.
  const paneProp = pane ? { pane } : {};
  return (
    <Tooltip
      {...paneProp}
      className={styles.container}
      direction="top"
      sticky={false}
      permanent={false}
      interactive={false}
      opacity={1}
    >
      <div className={styles.title}>{title}</div>
      {children}
    </Tooltip>
  );
};
